// Profile.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function Profile(props) {

  const profile4PersonalRef = useRef(null);
  const profile4SystemRef = useRef(null);

  const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
  const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
  const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
  const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

  const dispatch = useDispatch(); // dispatch(
  const credential = useSelector((state) => state.signIn.credential);
  const userListItem = useSelector((state) => state.home.userListItem);

  const [userListItemToBeChanged, setUserListItemToBeChanged] = useState({...userListItem, Password: ''});
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleOnClickSave = async (event) => {

    event.preventDefault();

    const personal = await profile4PersonalRef.current.validateInputs();
    const system = await profile4SystemRef.current.validateInputs();

    if (personal && system) {
      const updatedPersonal = profile4PersonalChanged(userListItemToBeChanged, personal);
      const updatedPersonalSystem = profile4SystemChanged(updatedPersonal, system);
      setUserListItemToBeChanged(updatedPersonalSystem);
      dispatch(setUserListItem(updatedPersonalSystem));
      const item = {
        ...updatedPersonalSystem, 
        Credential: credential,                 
        Updated: { 
            LastName: true,
            FirstName: true,
            YearOfBirth: true,
            Gender: true,
            TimeZoneID: true,
            Password: updatedPersonalSystem.Password.length === 0 ? false : true,
            VerseFontSize: true,
            VerseSearchResultPerPage: true,
            NotePerPage: true,
            HistoryListItemTotal: true,
        }
      };
      putUserListItem(item, 'Profile');
      setSnackbarOpen(true);
    }

  }

  const handleCloseSnackbar = async () => {
      setSnackbarOpen(false);
  }

  const profile4SystemChanged = (a, b) => {
    return {...a, 
      VerseSearchResultPerPage: b.VerseSearchResultPerPage,
      NotePerPage: b.NotePerPage,
      HistoryListItemTotal: b.HistoryListItemTotal,
      VerseFontSize: b.VerseFontSize,
    }
  }

  const profile4PersonalChanged = (a, b) => {
    return {...a, 
        LastName: b.LastName,
        FirstName: b.FirstName,
        YearOfBirth: b.YearOfBirth,
        Gender: b.Gender,
        TimeZoneID: b.TimeZoneID,
        Password: b.Password.length === 0 ? a.Password : b.Password,
    }
  }

  return (

    <div>

      <Navbar />

      <div style={{ paddingTop: '50px' }}>

        <Container maxWidth='sm' sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', overflowY: 'auto' }}>

            <Grid container spacing={2} padding={2}>

              <Grid size={12}>
                <Profile4Personal ref={profile4PersonalRef} mode={'Put'} userListItem={userListItemToBeChanged}/>
              </Grid>

              <Grid size={12}>
                <Profile4System ref={profile4SystemRef} userListItem={userListItemToBeChanged}/>
              </Grid>

              <Grid size={12} sx={{ paddingTop: '50px', paddingBottom: '100px', alignItems: 'center' }}>
                  <IconButton
                      sx={{
                          borderRadius: 1,
                          bgcolor: 'primary.main',
                          '&:hover': { bgcolor: 'primary.main' },
                          width: '100%',
                      }}
                      onClick={handleOnClickSave}
                  >
                      <CheckIcon sx={{ color: 'white' }} />
                  </IconButton>   
              </Grid>  

            </Grid>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={2500}
                onClose={handleCloseSnackbar}
                message="已經更新"
                sx={{ width: '50%' }}
            />          

          </div>

        </Container>

      </div>

    </div>

  );

};